import { FormattedMessage } from 'react-intl';

import { Season26TutorialDialog } from '@sorare/core/src/components/dialog/Season26TutorialDialog';
import { Season26TutorialStep } from '@sorare/core/src/components/dialog/Season26TutorialStep';
import { glossary } from '@sorare/core/src/lib/glossary';

import { QuickPlayTutorialHeader } from 'components/quickPlay/QuickPlayTutorialHeader';

import { QuickPlayTutorialFooter } from '../QuickPlayTutorialFooter';
import type { QuickPlayTutorialDialogType } from '../types';
import { Actions } from './Actions';
import { Milestones } from './Milestones';
import { NegativeActions } from './NegativeActions';
import background from './assets/background.png';

type Props = {
  open: boolean;
  onContinue: () => void;
  loading: boolean;
  onSelect: (type: QuickPlayTutorialDialogType) => void;
};
export const ScoringDialog = ({
  open,
  onContinue,
  loading,
  onSelect,
}: Props) => {
  return (
    <Season26TutorialDialog
      open={open}
      onClose={onContinue}
      color="#78C2FF"
      textColor="var(--c-black)"
      headerBackgroundUrl={background}
      disableAnimation
      hideTextureBackground
      gap={2}
      titleGroup={
        <QuickPlayTutorialHeader
          overline={<FormattedMessage {...glossary.howToPlay} />}
          title={
            <FormattedMessage
              id="ScoringDialog.title"
              defaultMessage="Scoring"
            />
          }
        />
      }
      items={[
        <Season26TutorialStep
          stepTitle={
            <FormattedMessage
              id="QuickplayTutorialDialog.scoring.actions"
              defaultMessage="Actions"
            />
          }
          key="l10-average"
          fullHeight={false}
        >
          <Actions />
        </Season26TutorialStep>,
        <Season26TutorialStep
          stepTitle={
            <FormattedMessage
              id="QuickplayTutorialDialog.scoring.milestones"
              defaultMessage="Milestones"
            />
          }
          key="targets"
          fullHeight={false}
        >
          <Milestones />
        </Season26TutorialStep>,
        <Season26TutorialStep
          stepTitle={
            <FormattedMessage
              id="QuickplayTutorialDialog.scoring.negativeActions"
              defaultMessage="Negative Actions"
            />
          }
          key="success"
          fullHeight={false}
        >
          <NegativeActions />
        </Season26TutorialStep>,
      ]}
      footer={
        <QuickPlayTutorialFooter
          onSelect={onSelect}
          onContinue={onContinue}
          loading={loading}
          selectedType="scoring"
        />
      }
    />
  );
};
